<template>
  <component
    :is="activeComponent"
    @next="next"
    @prev="prev"
    @toReview="toReview"
    @showRecipientInformation="showRecipientInformation"
  />
</template>

<script>
import country from '@/mixins/getCountryDetails.js'
export default {
  name: 'Recipient',
  mixins: [country],
  data () {
    return {
      activeComponent: 'RecipientOption'
    }
  },
  components: {
    RecipientOption: () => import('./RecipientOption.vue'),
    RecipientInformation: () => import('./../RecipientInformation.vue')
  },
  methods: {
    showRecipientInformation () {
      this.activeComponent = 'RecipientInformation'
    },
    toReview () {
      this.$emit('toReview')
    },
    prev () {
      this.$emit('prev')
    },
    next () {
      this.$emit('next')
    }
  },
  computed: {
    recipientInfo () {
      return this.$store.state.terminal.transferTerminalDetails
        .recipientInformation
    },
    beneficiaryOption () {
      return this.$store.state.terminal.beneficiaryOption
    },
    secondaryCurrency () {
      return this.country2.currency
    },
    beneficiariesArray () {
      const beneficiaries = this.$store.state.terminal.beneficiaries.filter(
        (beneficiary) =>
          beneficiary.destinationCurrency === this.secondaryCurrency
      )
      return beneficiaries
    }
  },
  beforeMount () {
    if (!this.beneficiaryOption) {
      this.activeComponent = 'RecipientInformation'
    }
    if (!this.beneficiariesArray || this.beneficiariesArray.length === 0) {
      this.activeComponent = 'RecipientInformation'
    }
  }
}
</script>
